import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { AlertBanner } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { DataCollectionInProgressBannerWrapper } from "./styles";

export const DataCollectionInProgressBanner = () => {
    const { translate } = useTranslate();

    return (
        <DataCollectionInProgressBannerWrapper>
            <AlertBanner
                variant="info"
                shadowed
                data-automation="rank-tracker-data-collection-banner"
            >
                <AlertBanner.Image />
                <AlertBanner.Description>
                    <Stack gap="4px">
                        <Text
                            fontVariant="subtitle1"
                            color={colorsPalettes.carbon[500]}
                        >
                            {translate("rankTracker.shared.data_collection_in_progress_banner.title")}
                        </Text>
                        <Text
                            fontVariant="body1"
                            color={colorsPalettes.carbon[400]}
                        >
                            {translate("rankTracker.shared.data_collection_in_progress_banner.body")}
                        </Text>
                    </Stack>
                </AlertBanner.Description>
            </AlertBanner>
        </DataCollectionInProgressBannerWrapper>
    );
};
